<template>
  <div class="fy-bc-body">
    <div
      v-if="bubbleShown"
      class="speech-bubble text-gray translate"
      :style="{
        top: bubbleTop + 'px',
        left: bubbleLeft + 5 + 'px',
      }"
    >
      {{ bubbleTitle }}
    </div>
    <div
      v-if="colorsShown"
      v-click-outside="
        () => {
          colorsShown = false;
        }
      "
      class="speech-bubble text-gray fy-colors"
      :style="{
        top: colorTop + 'px',
        left: colorLeft + 'px',
      }"
    >
      <div
        v-for="c in colors"
        :key="`col-${c.id}`"
        class="color-wrap"
        :class="{
          selected: c.id === bank.color,
          clickable: c.id !== bank.color,
        }"
        @click="() => true"
      >
        <div
          class="color-circle"
          :style="{'background-color': getColor(c.id)}"
        />
      </div>
    </div>
    <DeleteConfirmationPopup
      v-if="popupConfirmDeleteAccount"
      :deleting="deletingAccount"
      @close="popupConfirmDeleteAccount = null"
      @confirmed="confirmDeleteAccount"
    >
      La suppression de cette compte entraînera I'effacement de toutes Ies
      données dans la base de données Fygr. Cette action est irréversible.
    </DeleteConfirmationPopup>
    <div class="fy-bc-bank">
      <FygrInput
        class="fy-bc-bname"
        :debounce-events="['input', 'keyup']"
        :placeholder="bank.name"
        :value-in="bank.custom_name || bank.name"
        no-prompt
        exclude-translation
        @focusout="renameBank"
      />
      <div class="fy-bc-tools text-gray translate">
        Édition :
        <div class="fy-bc-icons">
          <!--
          <div
            class='fy-bc-icon clickable'
            :class="{ 'fy-green': bankNameEditable }"
            @click='bankNameEditable = !bankNameEditable'
            @mouseenter="(e) => showBubble(e, true, 'Renommer', 45, -26)"
            @mouseleave="(e) => showBubble(e, false)"
          >
            <i class='fi-edit' />
          </div>
          -->
          <div
            class="fy-bc-icon clickable"
            @click="$emit('remove', bank.id)"
            @mouseenter="(e) => showBubble(e, true, 'Supprimer', 45, -26)"
            @mouseleave="(e) => showBubble(e, false)"
          >
            <i class="fi-delete" />
          </div>
          <div
            v-if="false"
            class="fy-bc-icon clickable"
            @click="
              showColors($event, -30, -48);
              showBubble($event, false);
            "
            @mouseenter="
              (e) => showBubble(e, true, 'Modifier la couleur', 45, -46)
            "
            @mouseleave="(e) => showBubble(e, false)"
          >
            <i class="fi-palette big" />
          </div>
          <div
            :key="pinKey"
            class="fy-bc-icon clickable"
            :class="{
              'fy-green': isPinned.pinned,
            }"
            @click.stop="
              pinAccounts(bank.id, accountIds, !isPinned.all);
              showBubble(e, false);
            "
            @mouseenter="
              (e) =>
                showBubble(
                  e,
                  true,
                  isPinned.all ? 'Retirer l\'épingle' : 'Épingler',
                  45,
                  isPinned.all ? -40 : -18,
                )
            "
            @mouseleave="(e) => showBubble(e, false)"
          >
            <i class="fi-pin" />
          </div>
        </div>
      </div>
    </div>
    <div class="fy-bc-accs">
      <div
        v-for="acc in bank.accounts"
        :key="`fy-bc-${acc.id}`"
        class="fy-bc-acc"
      >
        <FygrInput
          class="fy-bc-acc-in"
          :debounce-events="['input', 'keyup']"
          :placeholder="acc.name"
          :value-in="acc.custom_name || acc.name"
          exclude-translation
          no-prompt
          @focusout="(e) => renameAccount(e, acc.id)"
        />
        <div class="fy-bc-balance text-gray not-translate">
          {{
            formatCurrency(acc.balance, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
              currency: acc.currency,
            })
          }}
        </div>
        <div
          class="fy-bc-pin red"
          @click.stop="deleteAccount(bank.id, acc.id)"
          @mouseenter="(e) => showBubble(e, true, 'Supprimer', 45, -20)"
          @mouseleave="(e) => showBubble(e, false)"
        >
          <i class="fi-delete" />
        </div>
        <div
          class="fy-bc-pin"
          :class="{'fy-bc-pin-green': acc.pinned}"
          @click.stop="pinAccounts(bank.id, [acc.id], !acc.pinned)"
          @mouseenter="
            (e) =>
              showBubble(
                e,
                true,
                acc.pinned ? 'Retirer l\'épingle' : 'Épingler',
                45,
                acc.pinned ? -35 : -10,
              )
          "
          @mouseleave="(e) => showBubble(e, false)"
        >
          <i class="fi-pin" />
        </div>
      </div>
    </div>
    <!--
    <div class="fy-bc-link" @click="modifyBank">
      <FontAwesomeIcon icon="plus" />
      Rechercher d’autres comptes pour cette banque
    </div>
    -->
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';
import {mapActions, mapState} from 'vuex';
import DeleteConfirmationPopup from '@/components/elements/popups/DeleteConfirmationPopup.vue';
import {formatMixin} from '@/mixins/formatMixin';

export default {
  name: 'BankConfig',
  components: {DeleteConfirmationPopup},
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mixins: [formatMixin],
  props: {
    bank: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['remove'],
  data() {
    return {
      pinKey: 0,
      bubbleLeft: 0,
      bubbleShown: false,
      bubbleTitle: '',
      bubbleTop: 0,
      colorLeft: 0,
      colorTop: 0,
      colorsShown: false,
      deletingAccount: false,
      popupConfirmDeleteAccount: null,
      vsoConfig: {
        handler: () => {
          this.showSubmenu = false;
        },
        events: ['mousedown'],
      },
    };
  },
  computed: {
    ...mapState('app', ['colors']),
    ...mapState('app', ['categories', 'scaleRatio']),
    accountIds() {
      return this.bank.accounts.map((a) => a.id);
    },
    getColor() {
      return (id) => {
        const color = this.colors.find((c) => c.id === id);
        return color.hex_code;
      };
    },
    isPinned() {
      const pinnedStateList = this.bank.accounts.map((a) => a.pinned);
      const pinned = pinnedStateList.filter((a) => a);
      return {
        pinned: pinnedStateList.includes(true),
        all: pinned.length === pinnedStateList.length,
      };
    },
  },
  methods: {
    ...mapActions('bank', [
      'actionDeleteAccount',
      'actionGetModifyUrl',
      'actionRenameAccount',
      'actionRenameConnection',
      'actionPinAccounts',
    ]),
    ...mapActions('app', ['actionAddNotification']),
    ...mapActions('tracking', ['actionUpdateHubSpotObject']),
    deleteAccount(bankId, accountId) {
      this.popupConfirmDeleteAccount = {bankId, accountId};
    },
    async confirmDeleteAccount() {
      this.deletingAccount = true;
      await this.actionDeleteAccount(this.popupConfirmDeleteAccount);
      this.popupConfirmDeleteAccount = null;
      this.deletingAccount = false;
    },
    modifyBank() {
      this.actionUpdateHubSpotObject({
        HSObj: {
          type: 'deal',
          properties: {
            update_bank_connection_attempt: JSON.stringify({
              bank_name: this.bank.name,
              connector_name: this.bank.aggregator,
              state: this.bank.state,
              last_update: this.bank.last_update,
              attempt_date: Date(),
            }),
          },
        },
      });
      this.actionGetModifyUrl(this.bank.id);
    },
    pinAccounts(bankId, accountIds, pinned) {
      this.actionPinAccounts({
        bank_id: bankId,
        account_ids: accountIds,
        pinned,
      });
      this.pinKey += 1;
    },
    async renameAccount(e, id) {
      const res = await this.actionRenameAccount({
        connection_id: this.bank.id,
        name: e,
        account_id: id,
      });
      this.addNotification(res);
    },
    async renameBank(e) {
      const res = await this.actionRenameConnection({
        connection_id: this.bank.id,
        name: e,
      });
      this.addNotification(res);
    },
    addNotification(res) {
      if (!res) {
        return;
      }
      this.actionAddNotification({
        msg: res.error
          ? "Erreur : l'action a échoué."
          : 'Modification enregistrée.',
        color: res.error ? 'red' : 'green',
        disappearing: true,
        once: false,
      });
    },
    showBubble(e, show, title, fixY, fixX) {
      this.bubbleTitle = title;
      this.bubbleTop = e.clientY - e.offsetY + 5 - fixY / this.scaleRatio;
      this.bubbleLeft = e.clientX - e.offsetX - 15 + fixX / this.scaleRatio;
      this.bubbleShown = show;
    },
    showColors(e, fixY, fixX) {
      this.colorTop = e.clientY - e.offsetY - fixY + 5;
      this.colorLeft = e.clientX - e.offsetX - 10 + fixX;
      this.colorsShown = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.fy-bc-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .fy-bc-accs {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 2px;
    overflow: auto;
    max-height: var(--px223);
    margin-top: var(--px80);
  }
  .fy-bc-acc {
    display: flex;
    width: calc(100% - var(--px5));
    align-items: center;
    margin-bottom: var(--px30);
    padding-right: var(--px5);
    &:last-of-type {
      margin-bottom: 0;
    }
    .fy-bc-acc-in {
      min-width: var(--px200);
    }
    .fy-bc-balance {
      margin-left: auto;
      text-align: left;
    }
    .fy-bc-pin {
      display: flex;
      align-items: center;
      justify-content: center;
      width: var(--px30);
      height: var(--px30);
      border-radius: var(--px8);
      background-color: rgba($gray, 0.1);
      color: $gray;
      cursor: pointer;
      user-select: none;
      &:hover {
        filter: brightness(0.8);
      }
      &.red {
        background-color: rgba($red, 0.1);
        color: $red;
        margin-right: var(--px15);
        margin-left: var(--px15);
      }
      i {
        margin-top: var(--px2);
      }
      &.fy-bc-pin-green {
        background-color: rgba($green, 0.1);
        color: $green;
      }
    }
  }
  .fy-bc-tools {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: var(--px15);
    width: var(--px260);
    padding-left: var(--px5);
    margin-bottom: var(--px45);
    &:first-child {
      margin-top: 0;
    }
    .fy-dots {
      margin-bottom: var(--px2);
      margin-right: var(--px10);
    }
    .fy-da-ev-name {
      max-width: var(--px150);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: var(--px2);
    }
    .fy-bc-icons {
      display: flex;
      align-items: center;
      color: $gray;
      &.fy-event {
        flex: 1;
        .fy-bc-icon {
          margin-left: var(--px10);
          &:first-child {
            margin-left: auto;
          }
        }
      }
      .fy-bc-icon {
        margin-left: var(--px20);
        &.fy-green {
          color: $green;
        }
        i {
          display: flex;
          align-items: center;
          &.big {
            max-height: unset;
            font-size: var(--px20);
          }
        }
      }
    }
  }
  .speech-bubble.fy-colors {
    display: flex;
    min-width: var(--px96);
    max-width: var(--px96);
    padding: var(--px15);
    flex-wrap: wrap;
    &::after {
      bottom: unset;
      top: 0;
      border: var(--px5) solid transparent;
      border-bottom-color: white;
      border-top: 0;
      margin: 0;
      margin-right: calc(var(--px5) * -1);
      margin-top: calc(var(--px5) * -1);
    }
  }
  .fy-bc-link {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: $blue;
    align-self: flex-start;
    margin-top: var(--px30);
    svg {
      margin-right: var(--px15);
    }
  }
}
</style>
